<template>
    <div class="bo-product-quantity-uom-counter">
        <template v-if="product.type === 'variable'">
            <bo-select 
                class="bo-uom-select" 
                :value="product.selected_uom" 
                :options="uomSlugs" 
                :labels="uomLabels" 
                :visible-items="5" 
                :disabled="uomDisabled" 
                :no-stock="noStock"
                @change="changeSelectedUom"
            ></bo-select>
            <bo-numeric-counter 
                class="bo-qty-counter" 
                :editable="true" 
                v-model="productQuantity" 
                :min="1" 
                :quantity-decimal-place="decimalPlace"
            ></bo-numeric-counter>
        </template>
        <template v-else>
            <bo-numeric-counter 
                class="bo-qty-counter bo-qty-counter--solo" 
                :editable="true" 
                v-model="productQuantity" 
                :min="1" 
                :quantity-decimal-place="decimalPlace"
            ></bo-numeric-counter>
        </template>
    </div>
</template>

<script>
import boNumericCounter from "js/frontend/components/bo-numeric-counter.vue";

export default {
    components: { boNumericCounter },
    directives: {
        clickOutside: {
            bind(el, binding) {
                el._clickOutsideHandler = (event) => {
                    if (!el.contains(event.target)) binding.value(event);
                };
                document.addEventListener("click", el._clickOutsideHandler, true);
            },
            unbind(el) {
                document.removeEventListener("click", el._clickOutsideHandler, true);
            },
        },
    },
    props: {
        product: {
            type: Object,
            required: true,
        },
        quantity: {
            type: Number,
            required: true,
        },
        uomDisabled: {
            type: Boolean,
            default: false,
        },
        noStock: {
            type: Boolean,
            default: false,
        },
        decimalPlace: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            isDropdownOpen: false,
        };
    },
    computed: {
        productQuantity: {
            get() {
                return this.quantity;
            },
            set(newValue) {
                this.$emit("change_quantity", newValue);
            },
        },
        productUomList() {
            if (this.product && this.product.uom) {
                return Array.isArray(this.product.uom)
                    ? this.product.uom
                    : Object.values(this.product.uom);
            }
            return [];
        },
        uomSlugs() {
            return this.productUomList.map(uom => uom.slug);
        },
        uomLabels() {
            const labels = {};
            this.productUomList.forEach(uom => {
                labels[uom.slug] = uom.name;
            });
            return labels;
        },
    },
    methods: {
        toggleDropdown() {
            if (this.uomDisabled) return;
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        closeDropdown() {
            this.isDropdownOpen = false;
        },
        selectUom(uom) {
            this.$emit("change_uom", uom);
            this.closeDropdown();
        },
        changeSelectedUom(uom) {
            this.$emit("change_uom", uom);
        },
    },
};
</script>
